import { keys as registrationKeys } from '../../detail/registration/queries';
import { PatchedResultWriteRequest, ResultWriteRequest } from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys as recordKeys } from '~/pages/record/queries';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateResultsMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ payload }: { payload: ResultWriteRequest }) => {
      return await SSF.api.resultsCreate({
        ...payload,
      });
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: registrationKeys.lists() });
    },
  });
}

export function useDeleteResultsMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.resultsDestroy>[0]) => SSF.api.resultsDestroy(variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: registrationKeys.lists() });
    },
  });
}

export function useUpdateResultsMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: { id: number; payload: PatchedResultWriteRequest }) => {
      return await SSF.api.resultsPartialUpdate(id, payload);
    },
    onSuccess: ({ data }) => {
      client.invalidateQueries({ queryKey: keys.detail(data.id) });
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: recordKeys.lists() });
    },
  });
}
